import BaseApi from '../BaseApi';
import { MyStatisticsApiConverter } from './MyStatisticsApiConverter';

class MyStatisticsApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/mini_admin`;
    this.converter = new MyStatisticsApiConverter();
  }

  getStatistic = ({ formData }) => {
    return this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/agent_structure_statistic`,
      formData,
      undefined,
      this.converter.convertStatistic,
    );
  }

  getBalanceStatistic = ({ formData }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/agent_structure_balance_statistic`,
      formData,
      undefined,
      this.converter.convertBalanceStatistic,
    );
}

export default MyStatisticsApi;
